"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMetrics = exports.METRICS_SITE = void 0;
const KatalMetrics = __importStar(require("@amzn/katal-metrics"));
const katal_metrics_driver_sushi_1 = __importDefault(require("@amzn/katal-metrics-driver-sushi"));
const KatalMetricsDriverConsoleLogJson_1 = __importDefault(require("@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson"));
const KatalMetricsDriverArrayCollector_1 = __importDefault(require("@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector"));
const radash_1 = require("radash");
const detectDomainRealm_1 = require("./detectDomainRealm");
exports.METRICS_SITE = 'BrandRegistry';
// eslint-disable-next-line no-console
const metricsConsoleErrorHandler = (err) => console.error(err);
const makeMetricsDriver = () => {
    if (process.env.NODE_ENV === 'test') {
        const metricsDriver = new KatalMetricsDriverArrayCollector_1.default();
        //  Attach to global window object so tests can see it
        window.metricsDriver = metricsDriver;
        return metricsDriver;
    }
    else if (process.env.NODE_ENV === 'development') {
        return new KatalMetricsDriverConsoleLogJson_1.default();
    }
    const domainRealm = (0, detectDomainRealm_1.detectDomainRealm)();
    return new katal_metrics_driver_sushi_1.default.Builder()
        .withDomainRealm(domainRealm.domain, domainRealm.realm)
        .withErrorHandler(metricsConsoleErrorHandler)
        .build();
};
const mainMetrics = (0, radash_1.memo)((customerId, appName) => {
    const metricsDriver = makeMetricsDriver();
    const initialMetricsContext = new KatalMetrics.Context.Builder()
        .withSite(exports.METRICS_SITE)
        .withServiceName(appName)
        .withRelatedMetrics(new KatalMetrics.Metric.String('customerId', customerId))
        .build();
    return new KatalMetrics.Publisher(metricsDriver, metricsConsoleErrorHandler, initialMetricsContext);
});
/**
 * Returns a Katal Metrics publisher that's specific to the component that called this hook.
 *
 * @param customerId - The customer ID of the customer to which this metric relates.
 * @param appName - The name of the application to which the calling component belongs.
 * @param componentName - The name of the calling component, e.g. "QuickLinksCard."
 */
exports.useMetrics = (0, radash_1.memo)((customerId, appName, componentName) => mainMetrics(customerId, appName).newChildActionPublisherForMethod(componentName));
